import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import icons from "./icons";
import style from "./style";
import types from "./types";

@define("m-feedback")
class Feedback extends HTMLElement {
  #data;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @willPaint
  async [trait.fetch]() {
    const { data } = await supabase
      .from("feedback_video")
      .select("*")
      .eq("user_id", this.dataset.user)
      .eq("video_id", this.dataset.video)
      .single();

    this.#data = data;
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <section class="${style.feedback}">
        <button class="${style.feedback__button}" id="${types.like}" selected="${this.#data?.feedback_id == types.like}">
          ${icons.loved()}
        </button>
        <div class="${style.feedback__separator}"></div>
        <button class="${style.feedback__button}" id="${types.dislike}" selected="${this.#data?.feedback_id == types.dislike}">
          ${icons.like()} 
        </button>
        <div class="${style.feedback__separator}"></div>
        <button class="${style.feedback__button}" id="${types.loved}" selected="${this.#data?.feedback_id == types.loved}">
          ${icons.dislike()}
        </button>
      </section>
    `;
  }

  @on.click("button")
  @repaint
  async [trait.push](event) {
    if (this.#data) {
      if (this.#data.feedback_id == event.target.id) {
        await supabase.from("feedback_video").delete().eq("id", this.#data.id);

        return this;
      }

      await supabase
        .from("feedback_video")
        .update({ feedback_id: event.target.id })
        .eq("id", this.#data.id);

      return this;
    }

    await supabase.from("feedback_video").insert([
      {
        user_id: this.dataset.user,
        video_id: this.dataset.video,
        feedback_id: event.target.id,
      },
    ]);
  }
}

export default Feedback;
